<template>
	<app-content class="h-panel">
		
		<router-view/>
	</app-content>
</template>

<script>
	export default {
		name: "stores",
		data() {
			return {
				selected: 'stores'
			}
		},
		methods: {
			change(data) {
				this.$router.push({name: data.key})
			}
		}
	}
</script>